// extracted by mini-css-extract-plugin
module.exports = {"servicePageWrapper":"page-module--servicePageWrapper--1zd2N"};